// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-waterfall';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.576 16.344h16.848M10.728 2.232v9.504h3.384V2.232a.568.568 0 0 0-.576-.576h-2.232a.568.568 0 0 0-.576.576z' />
    <path
      fill='currentColor'
      d='M7.344 7.2v4.536h3.384V7.2a.568.568 0 0 0-.576-.576H7.92a.568.568 0 0 0-.576.576z'
    />
    <path d='M3.96 2.232v7.344h3.384V2.232a.568.568 0 0 0-.576-.576H4.536a.568.568 0 0 0-.576.576z' />
    <path
      fill='currentColor'
      d='M14.112 2.304v14.04h3.384V2.232a.568.568 0 0 0-.576-.576h-2.232c-.288 0-.504.288-.576.648z'
    />
    <path d='M.576 2.304v14.04H3.96V2.232a.568.568 0 0 0-.576-.576H1.152c-.288 0-.504.288-.576.648z' />
  </g>
);

export const viewBox = '0 0 18 18';
